import React, { Component } from "react";
import { Loader, Segment } from "semantic-ui-react";
import { redirectToAccountApp } from "../../modules/accountApp";

class AccountAppRedirect extends Component {
  componentDidMount() {
    redirectToAccountApp(this.props.path);
  }

  render() {
    return (
      <Segment basic>
        <Loader active inline="centered">
          Taking you to your Hozah account
        </Loader>
      </Segment>
    );
  }
}

export const redirectRoute = (path) => () => <AccountAppRedirect path={path} />;

export default AccountAppRedirect;
